import { createSelector } from 'reselect';

const selectLoginState = state => state.loginState;

export const makeSelectErrorStatus = () =>
  createSelector(
    selectLoginState,
    substate => substate.showError
  );
